import React, { useState } from 'react';
import { Button, Menu, MenuItem, TextField, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  newButton: {
    marginTop: theme.spacing(-1),
    height: '28px',
  },
  textField: {
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(-1.25),
    marginLeft: theme.spacing(0.25),
    marginRight: theme.spacing(1),
  },
}));

const DropdownWithTextField = (props) => {
  const { items, values, newItemPrefix, onSelect, button, heading, anchorEl, setAnchorEl } = props;

  const classes = useStyles();
  const [newItem, setNewItem] = useState('');

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (item) => {
    onSelect(item);
    handleClose();
  };

  const handleNewItemTextChange = (event) => {
    const unsafePattern = /[^a-zA-Z0-9_\-\. ]/g;  // Allow alphanumeric, hyphen, underscore, period, space
    setNewItem(event.target.value.replace(unsafePattern, ''));
  };

  const handleCreateNewItem = () => {
    if (newItem.trim() !== '') {
      onSelect(newItem.trim());
      setNewItem('');
      handleClose();
    }
  };

  return (
    <div>
      {button ? button :
        <Button
          className={classes.button}
          variant="outlined"
          onClick={handleClick}
        >
          Select Item
        </Button>
      }
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {heading && heading}
        {items && items.map((item, index) => (
          <MenuItem key={index} onClick={() => handleSelect(values[index])}>
            {item}
          </MenuItem>
        ))}
        <MenuItem
          key='new'
          onKeyDown={e => e.stopPropagation()}
        >
          {newItemPrefix && newItemPrefix}
          <TextField
            className={classes.textField}
            placeholder='New folder'
            size='small'
            value={newItem}
            onChange={handleNewItemTextChange}
          />
          <Button
            className={classes.newButton}
            variant='contained'
            size='small'
            onClick={handleCreateNewItem}
            disabled={newItem.length === 0}
          >
            Create
          </Button>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default DropdownWithTextField;
